<template>
  <div :class="$style['v-slider']">
    <transition
      name="slide"
      tag="div"
      :css="false"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
      :class="$style['content']"
    >
      <slot></slot>
    </transition>
  </div>
</template>

<script>
import velocity from 'velocity-animate'

export default {
  data: () => ({
    currentIndex: 0,
  }),
  methods: {
    nextSlide() {
      this.currentIndex += 1
    },
    beforeEnter(el) {
      velocity(el, { opacity: 0, translateX: '20%' })
    },
    enter(el, done) {
      velocity(el, { opacity: 1, translateX: '0%' }, { complete: done })
    },
    leave(el, done) {
      velocity(el, { opacity: 0, translateX: '-20%' }, { complete: done })
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.v-slider {
  // display: flex;
  flex: 1;
  overflow: hidden;
  // width: 100%;
  // height: 100%;

  .content {
    display: block;
  }
}
</style>
